import api from '../config/api';

// Note: the API also returns a `default_text` per channel, but it's a generic
// server-side fallback (e.g. "Communication from <program name>") that pony
// already applies at publish time when no per-content message is supplied.
// It is not a user-configured default and is intentionally omitted here.
export type NotificationChannelConfig = {
  enabled: boolean;
  default: boolean;
};

export type NotificationChannelsConfiguration = {
  email: NotificationChannelConfig;
  notification_center: NotificationChannelConfig;
  push: NotificationChannelConfig;
};

export type SubmissionsMetadataResponse = {
  data: {
    attributes: {
      composer: {
        notification_channels_configuration: NotificationChannelsConfiguration;
      };
    };
  };
};

class SubmissionsMetadataService {
  fetch = () => {
    return api.get<SubmissionsMetadataResponse>('/submissions/metadata');
  };
}

export default SubmissionsMetadataService;
